/**
 *
 * Container: HardReset
 * Date: 21/7/2021
 *
 */

import React, { useEffect } from 'react';

import mixpanel from 'utils/mixpanel';
import { parseJwt } from 'utils/commonFunctions';

import styles from './style.module.css';

function getLocalStorageValue(key: string) {
  return localStorage.getItem(key) || '';
}
export function HardReset() {
  const getPermissions = () => {
    const accessTokenStorage = getLocalStorageValue('access_token');
    const parseJwtValue = parseJwt(accessTokenStorage);
    if (!parseJwtValue) {
      return '';
    }
    const aud = Array.isArray(parseJwtValue.aud)
      ? parseJwtValue.aud[0]
      : parseJwtValue.aud;
    return parseJwtValue[`${aud}/claims/permissions`];
  };

  const handleHardReset = async () => {
    let cacheLength = 0;
    const cookiesLength = document.cookie?.split('; ')?.length;
    const localStorageLength = localStorage.length;

    // delete cache
    await caches.keys().then((cacheNames) => {
      cacheLength = cacheNames.length;
      Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
    });

    // add Mixpanel event
    mixpanel('Hard Reset', 'HardReset', {
      cacheLength,
      cookiesLength,
      localStorageLength,
      permissionsOfUser: getPermissions(),
      tokenExpiresAt: getLocalStorageValue('expires_at'),
    });

    // localStorage clear
    localStorage.clear();

    // cookies clear
    (function deleteAllCookies() {
      const cookies = document.cookie.split(';');

      for (let i = 0; i < cookies.length; i += 1) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      }
    })();

    // reload page so that it redirects to login
    setTimeout(() => {
      window.location.assign('/');
    }, 1000);
  };

  useEffect(() => {
    handleHardReset();
  }, []);

  return <div className={styles.container}>Resetting App...</div>;
}

export default HardReset;
